var win = $(window), drawer_flag = false, scrollPoint = 0;
const whiteout = function(flag, identifier){
  if(identifier === undefined) {
    identifier = 'drawer';
  }
  if(flag === false) {
    $('#whiteout' + '-' + identifier).remove();
  } else {
    if($('#whiteout').length > 0) return false;
    $('body').append($('<div>').attr({id: 'whiteout' + '-' + identifier, 'data-identifier': identifier}).addClass('whiteout').css({opacity: 0}));
    TweenLite.fromTo('#whiteout' + '-' + identifier, .3, {display: 'block', opacity: 0}, {opacity: 1});
  }
};
const drawer = function($this){
  if(drawer_flag) return;
  drawer_flag = true;
  var identifier = $($this).attr('data-identifier'),
      target = $($this).attr('data-target'),
      behavior = $($this).attr('data-behavior'),
      item_delay = $($this).attr('data-item_delay');
  if(item_delay === undefined) {
    item_delay = .3;
  }
  if($(target).is(':visible')) {
    // 閉じる
    $('body').css({
      overflow: 'auto'
    }).removeClass('is-open is-open--' + identifier);
    whiteout(false, identifier);
    if(behavior !== undefined && behavior === 'right') {
      TweenLite.to(target, .3, {x: '100%', onComplete: function(){
        $(target).hide();
        drawer_flag = false;
      }});
    } else if(behavior !== undefined && behavior === 'top') {
      TweenLite.to(target, .3, {y: '-100%', onComplete: function(){
        $(target).hide();
        drawer_flag = false;
      }});
    } else {
      TweenLite.to(target, .3, {x: '-100%', onComplete: function(){
        $(target).hide();
        drawer_flag = false;
      }});
    }
    $('a,input,select,textarea,button,object').attr('tabindex', '');
  } else {
    // 展開する
    // scrollBy( 0, 80);

    var tl = new TimelineLite();
    scrollPoint = win.scrollTop();
    $('body').css({
      // overflow: 'hidden'
    }).addClass('is-open is-open--' + identifier);
    whiteout(true, identifier);
    $('a,input,select,textarea,button,object').attr('tabindex', -1);
    $(target).find('a,input,select,textarea,button,object').attr('tabindex', '');
    if(item_delay > 0) {
      var items = $(target).find('.nav__item'), 
          item_speed = .5;
          var delay_sec =  item_delay;
          if((item_delay * items.length) > 3) {
            delay_sec = 3 / items.length;
          }
          delay_sec = delay_sec * -1;
    }
    if(behavior !== undefined && behavior === 'right') {
      if(item_delay > 0) {
        items.each(function(){
          tl.fromTo($(this), item_speed, {x: '30%', opacity: 0}, {ease: Power2.easeOut, x: '0%', opacity: 1, delay: delay_sec});
        });
      }
      TweenLite.fromTo(target, .5, {display: 'block', x: '100%'}, {x: '0%', onComplete: function(){
        drawer_flag = false;
      }});
    } else if(behavior !== undefined && behavior === 'top') {
      if(item_delay > 0) {
        tl.fromTo(target, .5, {display: 'block', y: '-100%'}, {y: '0%', onComplete: function(){
          drawer_flag = false;
        }});
        items.each(function(){
          tl.fromTo($(this), item_speed, {y: '-30%', opacity: 0}, {ease: Power2.easeOut, y: '0%', opacity: 1, delay: delay_sec});
        });
      }
    } else {
      if(item_delay > 0) {
        items.each(function(){
          tl.fromTo($(this), item_speed, {x: '-10%', opacity: 0}, {ease: Power2.easeOut, x: '0%', opacity: 1, delay: delay_sec});
        });
      }
      TweenLite.fromTo(target, .5, {display: 'block', x: '-100%'}, {x: '0%', onComplete: function(){
        drawer_flag = false;
      }});
    }
  }
};
$(function(){
  $('.is-toggle').on({
    click: function(event){
      event.preventDefault();
      drawer(this);
      return false;
    },
    touchend: function(event){
      event.preventDefault();
      drawer(this);
      return false;
    }
  });
  $(document).on({
    click: function(event){
      event.preventDefault();
      var identifier = $(this).attr('data-identifier')
      drawer($('.is-toggle[data-identifier=' + identifier + ']'));
      return false;
    },
    touchend: function(event){
      event.preventDefault();
      var identifier = $(this).attr('data-identifier')
      drawer($('.is-toggle[data-identifier=' + identifier + ']'));
      return false;
    }
  }, '.whiteout');

});
